// import React from 'react';
// import { Box, Typography, Avatar, Divider } from '@mui/material';

// const ProjectDetail = ({ project? }) => {
//   return (
//     <Box 
//       sx={{ 
//         maxWidth: 900, 
//         mx: 'auto', 
//         my: 6, 
//         px: 2 
//       }}
//     >
//       {/* Title */}
//       <Typography 
//         variant="h4" 
//         fontWeight="bold" 
//         gutterBottom
//       >
//         {project??.title || "Project Title Placeholder"}
//       </Typography>

//       {/* Main Image */}
//       <Box
//         component="img"
//         src={project??.image || "https://picsum.photos/900/400?random=2"}
//         alt={project??.title}
        // sx={{
        //   width: '100%',
        //   height: 'auto',
        //   borderRadius: 2,
        //   mb: 3,
        //   boxShadow: 2,
        // }}
//       />

//       {/* Publisher Info */}
//       <Box 
//         sx={{ 
//           display: 'flex', 
//           alignItems: 'center', 
//           mb: 3 
//         }}
//       >
//         <Avatar 
//           src={project??.publisherImg || "https://i.pravatar.cc/150?img=4"} 
//           alt={project??.publisherName || "Publisher"} 
//           sx={{ width: 56, height: 56, mr: 2 }}
//         />
//         <Box>
//           <Typography variant="subtitle1" fontWeight={600}>
//             {project??.publisherName || "John Doe"}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Published on {project??.date || "October 9, 2025"}
//           </Typography>
//         </Box>
//       </Box>

//       <Divider sx={{ mb: 3 }} />

//       {/* Story Content */}
//       <Typography 
//         variant="body1" 
//         color="text.primary" 
//         lineHeight={1.8}
//       >
//         {project??.story || `This project? focuses on creating meaningful community impact by
//         leveraging technology and innovation. Our goal was to deliver sustainable
//         change through collaboration, creativity, and measurable results.`}
//       </Typography>
//     </Box>
//   );
// };

// export default ProjectDetail;

// import React from 'react';
// import { Box, Typography, Avatar, Divider, Card, CardMedia, CardContent } from '@mui/material';
// import { useLocation } from 'react-router';

// const ProjectDetail = ({ project?, relatedArticles }) => {
//     const location = useLocation()
//   return (
//     <Box 
//       sx={{
//         display: 'flex',
//         flexDirection: { xs: 'column', md: 'row' },
//         gap: 4,
//         maxWidth: 1200,
//         mx: 'auto',
//         my: 6,
//         px: 2,
//       }}
//     >
    //   {/* LEFT: Main Project Details */}
    //   <Box flex={3}>
    //     {/* Title */}
    //     <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
    //       {project??.title || "Project Title Placeholder"}
    //     </Typography>

    //     {/* Main Image */}
    //     <Box
    //       component="img"
    //       src={project??.image || "https://picsum.photos/900/400?random=2"}
    //       alt={project??.title}
    //       sx={{
    //         width: '100%',
    //         height: 'auto',
    //         borderRadius: 2,
    //         mb: 3,
    //         boxShadow: 2,
    //       }}
          
    //     />

    //     {/* Publisher Info */}
    //     <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
    //       <Avatar 
    //         src={project??.publisherImg || "https://i.pravatar.cc/150?img=4"} 
    //         alt={project??.publisherName || "Publisher"} 
    //         sx={{ width: 56, height: 56, mr: 2 }}
    //       />
    //       <Box>
    //         <Typography variant="subtitle1" fontWeight={600}>
    //           {project??.publisherName || "John Doe"}
    //         </Typography>
    //         <Typography variant="body2" color="text.secondary">
    //           Published on {project??.date || "October 9, 2025"}
    //         </Typography>
    //       </Box>
    //     </Box>

    //     <Divider sx={{ mb: 3 }} />

    //     {/* Story */}
    //     <Typography variant="body1" color="text.primary" lineHeight={1.8}>
    //       {project??.story || `This project? focuses on creating meaningful community impact by
    //       leveraging technology and innovation. Our goal was to deliver sustainable
    //       change through collaboration, creativity, and measurable results.`}
    //     </Typography>
    //   </Box>

    //   {/* RIGHT: Related Articles */}
    //   <Box 
    //     flex={1.5} 
    //     sx={{
    //       position: { md: 'sticky' },
    //       top: { md: '90px' },
    //       alignSelf: 'flex-start'
    //     }}
    //   >
    //     <Typography variant="h6" fontWeight="bold" mb={2}>
    //       Related Articles
    //     </Typography>

    //     {relatedArticles?.map((article, index) => (
    //       <Card 
    //         key={index} 
    //         sx={{ mb: 2, borderRadius: 2, boxShadow: 1, cursor: 'pointer', transition: '0.3s',
    //               '&:hover': { boxShadow: 3 } }}
    //       >
    //         <CardMedia
    //           component="img"
    //           height="140"
    //           image={article.image || `https://picsum.photos/300/200?random=${index + 1}`}
    //           alt={article.title}
    //         />
    //         <CardContent>
    //           <Typography variant="subtitle1" fontWeight="bold">
    //             {article.title}
    //           </Typography>
    //           <Typography variant="body2" color="text.secondary">
    //             {article.date || "September 2025"}
    //           </Typography>
    //         </CardContent>
    //       </Card>
    //     ))}
    //   </Box>
//     </Box>
//   );
// };

// export default ProjectDetail


// import React from "react";
// import {
//   Box,
//   Typography,
//   Divider,
//   List,
//   ListItem,
//   ListItemText,
//   Avatar,
//   Stepper,
//   Step,
//   StepLabel,
//   useMediaQuery,
//   Card,
//   CardMedia,
//   CardContent
// } from "@mui/material";

// const ProjectDetail = ({ project, relatedArticles }) => {
//   const isMobile = useMediaQuery("(max-width:900px)");

//   const timeline = [
//     { title: "Pipeline", date: "17 Apr 2021", days: "1539 days" },
//     { title: "Approved", date: "03 Jul 2025", days: "102 days so far" },
//     { title: "Under implementation" },
//     { title: "To be completed" },
//   ];

//   const details = {
//     region: "Latin America and the Caribbean",
//     countries: ["Barbados", "Belize", "Jamaica"],
//     priorityGroup: "Small Island Developing States",
//   };

//   return (
    // <Box
    //   sx={{
    //     display: "flex",
    //     flexDirection: { xs: "column", lg: "row" },
    //     maxWidth: 1200,
    //     mx: "auto",
    //     mt: 6,
    //     px: 2,
    //     gap: 5,
    //   }}
    // >
//       {/* Left Side: Main Project */}
//       <Box flex={2.5}>
//         <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
//           {project?.title || "Project Title Placeholder"}
//         </Typography>

//         <Box
//           component="img"
//           src={project?.image || "https://picsum.photos/900/400?random=7"}
//           alt={project?.title}
//           sx={{
//             width: "100%",
//             height: "auto",
//             borderRadius: 2,
//             mb: 3,
//             boxShadow: 2,
//           }}
//         />

//         {/* Publisher */}
//         <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
//           <Avatar
//             src={project?.publisherImg || "https://i.pravatar.cc/150?img=10"}
//             alt={project?.publisherName || "John Doe"}
//             sx={{ width: 56, height: 56, mr: 2 }}
//           />
//           <Box>
//             <Typography fontWeight={600}>
//               {project?.publisherName || "John Doe"}
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               Published on {project?.date || "October 9, 2025"}
//             </Typography>
//           </Box>
//         </Box>

//         <Divider sx={{ mb: 3 }} />

//         {/* Story */}
//         <Typography variant="body1" color="text.primary" lineHeight={1.8}>
//           {project?.story ||
//             `This project? focuses on creating meaningful community impact by
//             leveraging technology and innovation. Our goal was to deliver
//             sustainable change through collaboration, creativity, and
//             measurable results.`}
//         </Typography>
//       </Box>

//       {/* Right Side: Timeline & Details */}

//       <Box
//         flex={1.5}
//         sx={{
//           backgroundColor: "#fff",
//           p: 3,
//           borderRadius: 3,
//           boxShadow: 1,
//           height: "fit-content",
//         }}
//       >
//         {/* Project Timeline */}
//         <Typography
//           variant="subtitle2"
//           sx={{ color: "green", textTransform: "uppercase", mb: 1 }}
//         >
//           Project Timeline
//         </Typography>
//         <Stepper
//           orientation="vertical"
//           activeStep={1}
//           connector={null}
//           sx={{
//             "& .MuiStepLabel-label": { fontWeight: 600 },
//           }}
//         >
//           {timeline.map((step, index) => (
//             <Step key={index}>
//               <StepLabel>
//                 <Typography variant="body1" fontWeight={600}>
//                   {step.title}
//                 </Typography>
//                 {step.date && (
//                   <Typography variant="body2" color="text.secondary">
//                     {step.date} • {step.days}
//                   </Typography>
//                 )}
//               </StepLabel>
//             </Step>
//           ))}
//         </Stepper>

//         <Divider sx={{ my: 3 }} />

//         {/* Region */}
//         <Typography
//           variant="subtitle2"
//           sx={{ color: "green", textTransform: "uppercase", mb: 1 }}
//         >
//           One Region
//         </Typography>
//         <Typography variant="h6" gutterBottom>
//           {details.region}
//         </Typography>

//         {/* Countries */}
//         <Typography
//           variant="subtitle2"
//           sx={{ color: "green", textTransform: "uppercase", mt: 3, mb: 1 }}
//         >
//           Countries
//         </Typography>
//         <List dense>
//           {details.countries.map((country, i) => (
//             <ListItem key={i} disablePadding>
//               <ListItemText
//                 primary={country}
//                 primaryTypographyProps={{
//                   fontSize: 15,
//                   fontWeight: 500,
//                 }}
//               />
//             </ListItem>
//           ))}
//         </List>

//         {/* Priority Group */}
//         <Typography
//           variant="subtitle2"
//           sx={{ color: "green", textTransform: "uppercase", mt: 3, mb: 1 }}
//         >
//           One Priority Group
//         </Typography>
//         <Typography variant="body1">{details.priorityGroup}</Typography>

//         <Box 
//         flex={1.5} 
//         sx={{
//           position: { md: 'sticky' },
//           top: { md: '90px' },
//           alignSelf: 'flex-start'
//         }}
//         >
//         <Typography variant="h6" fontWeight="bold" mb={2}>
//           Related Articles
//         </Typography>

//         {relatedArticles?.map((article, index) => (
//           <Card 
//             key={index} 
//             sx={{ mb: 2, borderRadius: 2, boxShadow: 1, cursor: 'pointer', transition: '0.3s',
//                   '&:hover': { boxShadow: 3 } }}
//           >
//             <CardMedia
//               component="img"
//               height="140"
//               image={article.image || `https://picsum.photos/300/200?random=${index + 1}`}
//               alt={article.title}
//             />
//             <CardContent>
//               <Typography variant="subtitle1" fontWeight="bold">
//                 {article.title}
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 {article.date || "September 2025"}
//               </Typography>
//             </CardContent>
//           </Card>
//         ))}
//       </Box>
//       </Box>
//     </Box>
//   );
// };

// export default ProjectDetail;

// import React, { useState } from "react";
// import {
//   Box,
//   Grid,
//   Typography,
//   Stepper,
//   Step,
//   StepLabel,
//   StepContent,
//   Button,
//   Paper,
//   Card,
//   CardMedia,
//   CardContent,
//   Avatar,
//   Divider,
// } from "@mui/material";


// const ProjectDetail = ({project}) => {
//     const [activeStep, setActiveStep] = useState(0);
  
//     // --- TIMELINE STEPS ---
//     const steps = [
//       {
//         label: "Pipeline",
//         description:
//           "Project proposed and under review for initial funding and feasibility analysis.",
//         date: "17 Apr 2021",
//       },
//       {
//         label: "Approved",
//         description:
//           "Funding approved and project implementation framework initiated.",
//         date: "03 Jul 2025",
//       },
//       {
//         label: "Under Implementation",
//         description:
//           "Ongoing execution phase — installations, team coordination, local partnerships.",
//         date: "Currently Active",
//       },
//       {
//         label: "To Be Completed",
//         description: "Final evaluation and reporting before project closure.",
//         date: "Expected Q3 2026",
//       },
//     ];
  
//     // --- RELATED ARTICLES ---
//     const relatedArticles = [
//       {
//         title: "Boosting Renewable Energy Access in Jamaica",
//         img: "https://picsum.photos/300/200?random=10",
//       },
//       {
//         title: "Community Empowerment through Clean Water",
//         img: "https://picsum.photos/300/200?random=12",
//       },
//       {
//         title: "How Small Islands Adapt to Climate Risks",
//         img: "https://picsum.photos/300/200?random=13",
//       },
//     ];
  
//     return (
//         <Box
//         sx={{
//           display: "flex",
//           flexDirection: { xs: "column", lg: "row" },
//           maxWidth: 1200,
//           mx: "auto",
//           mt: 6,
//           px: 2,
//           gap: 5,
//         }}
//       >
//         <Box flex={2.5}>
//           {/* LEFT SIDE - INTERACTIVE STEPPER */}
//           <Box item xs={12} md={3}>
//             <Typography variant="h6" sx={{ mb: 2 }}>
//               Project Timeline
//             </Typography>
  
//             <Stepper activeStep={activeStep} orientation="vertical">
//               {steps.map((step, index) => (
//                 <Step key={step.label}>
//                   <StepLabel>
//                     <Typography fontWeight={600}>{step.label}</Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {step.date}
//                     </Typography>
//                   </StepLabel>
//                   <StepContent>
//                     <Typography sx={{ mb: 2 }}>{step.description}</Typography>
//                     <Box>
//                       <Button
//                         disabled={index === 0}
//                         onClick={() => setActiveStep(index - 1)}
//                         sx={{ mr: 1 }}
//                       >
//                         Back
//                       </Button>
//                       <Button
//                         variant="contained"
//                         onClick={() =>
//                           index === steps.length - 1
//                             ? setActiveStep(0)
//                             : setActiveStep(index + 1)
//                         }
//                       >
//                         {index === steps.length - 1 ? "Reset" : "Next"}
//                       </Button>
//                     </Box>
//                   </StepContent>
//                 </Step>
//               ))}
//             </Stepper>
//           </Box>
  
//           {/* CENTER - PROJECT CONTENT */}

//              {/* LEFT: Main Project Details */}
//       <Box flex={6}>
//         {/* Title */}
//         <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
//           {project?.title || "Project Title Placeholder"}
//         </Typography>

//         {/* Main Image */}
//         <Box
//           component="img"
//           src={project?.image || "https://picsum.photos/900/400?random=2"}
//           alt={project?.title}
//           sx={{
//             width: '100%',
//             height: 'auto',
//             borderRadius: 2,
//             mb: 3,
//             boxShadow: 2,
//           }}
          
//         />

//         {/* Publisher Info */}
//         <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
//           <Avatar 
//             src={project?.publisherImg || "https://i.pravatar.cc/150?img=4"} 
//             alt={project?.publisherName || "Publisher"} 
//             sx={{ width: 56, height: 56, mr: 2 }}
//           />
//           <Box>
//             <Typography variant="subtitle1" fontWeight={600}>
//               {project?.publisherName || "John Doe"}
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               Published on {project?.date || "October 9, 2025"}
//             </Typography>
//           </Box>
//         </Box>

//         <Divider sx={{ mb: 3 }} />

//         {/* Story */}
//         <Typography variant="body1" color="text.primary" lineHeight={1.8}>
//           {project?.story || `This project? focuses on creating meaningful community impact by
//           leveraging technology and innovation. Our goal was to deliver sustainable
//           change through collaboration, creativity, and measurable results.`}
//         </Typography>
//       </Box>

//       {/* RIGHT: Related Articles */}
//       <Box 
//         flex={1.5} 
//         sx={{
//           position: { md: 'sticky' },
//           top: { md: '90px' },
//           alignSelf: 'flex-start'
//         }}
//       >
//         <Typography variant="h6" fontWeight="bold" mb={2}>
//           Related Articles
//         </Typography>

//         {relatedArticles?.map((article, index) => (
//           <Card 
//             key={index} 
//             sx={{ mb: 2, borderRadius: 2, boxShadow: 1, cursor: 'pointer', transition: '0.3s',
//                   '&:hover': { boxShadow: 3 } }}
//           >
//             <CardMedia
//               component="img"
//               height="140"
//               image={article.image || `https://picsum.photos/300/200?random=${index + 1}`}
//               alt={article.title}
//             />
//             <CardContent>
//               <Typography variant="subtitle1" fontWeight="bold">
//                 {article.title}
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 {article.date || "September 2025"}
//               </Typography>
//             </CardContent>
//           </Card>
//         ))}
//       </Box>
//       </Box>
//       </Box>
//     );
//   };
  
//   export default ProjectDetail;


import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Button,
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  Divider,
  Avatar,
} from "@mui/material";
import { Download, Assessment } from "@mui/icons-material";
import DonateCallToAction from "./DonateCallToAction";
import CommentSection from "./CommentSection";
import { ArticleGetBatch } from "../../api/orgService";
import useApi from "../../api/useApi";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";

const ProjectDetail = ({project}) => {
   console.log(project)
      const [activeStep, setActiveStep] = useState(0);
      const navigate = useNavigate()
      const [relatedArticles,setRelatedArticles]=useState([])
  
      const { request: getRelatedArticles, data:relatedArticlesData, error:relatedArticlesError,isLoading:getRelatedArticlesLoading} = useApi(ArticleGetBatch);
          
      useEffect(() => {
        if(project?.subcategory?.id){
          console.log("project: ",project)
        getRelatedArticles({subcategory:project?.subcategory?.id});
        }
              // eslint-disable-next-line
        }, [project]);
        
        useEffect(()=>{
          if (relatedArticlesData?.status===200) {
            setRelatedArticles(relatedArticlesData?.data?.results);
          }
        // eslint-disable-next-line
        },[relatedArticlesData])
  
      
      //   // useEffect(()=>{
      //   //     if(location?.state?.refresh==="org"){
      //   //       getAllResources();
      //   //     }
      //   //   // eslint-disable-next-line
      //   //   },[location?.state])
      
        useEffect(()=>{
            if(relatedArticlesError){
                toast.error(`${JSON.stringify(relatedArticlesError?.response?.data,null,2)}`,{position: "top-center"});
          }
        },[relatedArticlesError]) 
  

  // --- TIMELINE STEPS ---
  const steps = [
    {
      label: "Pipeline",
      description:
        "Project proposed and under review for initial funding and feasibility analysis.",
      date: "17 Apr 2021",
    },
    {
      label: "Approved",
      description:
        "Funding approved and project implementation framework initiated.",
      date: "03 Jul 2025",
    },
    {
      label: "Under Implementation",
      description:
        "Ongoing execution phase — installations, team coordination, local partnerships.",
      date: "Currently Active",
    },
    {
      label: "To Be Completed",
      description: "Final evaluation and reporting before project closure.",
      date: "Expected Q3 2026",
    },
  ];

  // --- RELATED ARTICLES ---
  // const relatedArticles = [
  //   {
  //     title: "Boosting Renewable Energy Access in Jamaica",
  //     img: "https://picsum.photos/300/200?random=10",
  //     url:"/articles/Boosting Renewable Energy Access in Jamaica"
  //   },
  //   {
  //     title: "Community Empowerment through Clean Water",
  //     img: "https://picsum.photos/300/200?random=12",
  //     url:"/articles/Community Empowerment through Clean Water"
  //   },
  //   {
  //     title: "How Small Islands Adapt to Climate Risks",
  //     img: "https://picsum.photos/300/200?random=13",
  //     url:"/articles/How Small Islands Adapt to Climate Risks"
  //   },
  // ];

//   ---- Project statistics
  const stats = [
    { label: "Total Funding", value: "$2.4M", color: "primary" },
    { label: "Beneficiaries", value: "25,000+", color: "success" },
    { label: "Countries", value: "3", color: "secondary" },
    { label: "Progress", value: "68%", color: "info" },
  ];

   // --- PROJECT REPORTS ---
   const reports = [
    {
      title: "Q1 2025 Progress Report",
      date: "May 10, 2025",
      link: "#",
    },
    {
      title: "Annual Report 2024",
      date: "Dec 31, 2024",
      link: "#",
    },
  ];
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 4,
        p: { xs: 2, md: 6 },
        justifyContent: "space-between",
      }}
    >
      {/* LEFT SIDE — INTERACTIVE STEPPER */}
      <Box
        sx={{
          flex: { xs: "1", md: "0 0 23%" },
          borderRight: { md: "1px solid #eee" },
          pr: { md: 3 },
        }}
      >
        <DonateCallToAction />
        <Typography variant="h6" sx={{ mb: 2 }}>
          Project Timeline
        </Typography>

        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((step, index) => (
            <Step key={step.label}>
              <StepLabel>
                <Typography fontWeight={600}>{step.label}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {step.date}
                </Typography>
              </StepLabel>
              <StepContent>
                <Typography sx={{ mb: 2 }}>{step.description}</Typography>
                <Box>
                  <Button
                    disabled={index === 0}
                    onClick={() => setActiveStep(index - 1)}
                    sx={{ mr: 1 }}
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() =>
                      index === steps.length - 1
                        ? setActiveStep(0)
                        : setActiveStep(index + 1)
                    }
                  >
                    {index === steps.length - 1 ? "Reset" : "Next"}
                  </Button>
                </Box>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Box>

      {/* CENTER — PROJECT MAIN CONTENT */}
      <Box
        sx={{
          flex: { xs: "1", md: "1 0 50%" },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box flex={3}>
        {/* Title */}
        <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
          {project?.name || "Project Title Placeholder"}
        </Typography>

        {/* Main Image */}
        <Box
          component="img"
          src={project?.image}
          alt={project?.name}
          sx={{
            width: '100%',
            height: 'auto',
            borderRadius: 2,
            mb: 3,
            boxShadow: 2,
          }}
          
        />

        {/* Publisher Info */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Avatar 
            src={project?.publisherImg || "https://i.pravatar.cc/150?img=4"} 
            alt={project?.publisherName || "Publisher"} 
            sx={{ width: 56, height: 56, mr: 2 }}
          />
          <Box>
            <Typography variant="subtitle1" fontWeight={600}>
              {project?.publisherName || "John Doe"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Published on {project?.date || "October 9, 2025"}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* Story */}
        <Typography variant="body1" color="text.primary" lineHeight={1.8}>
          {project?.story || `This project? focuses on creating meaningful community impact by
          leveraging technology and innovation. Our goal was to deliver sustainable
          change through collaboration, creativity, and measurable results.`}
        </Typography>

        <Divider sx={{ my: 3 }} />

        {/* 📊 PROJECT STATISTICS */}
        <Box>
        <Typography variant="h6" sx={{ mb: 2 }}>
            Project Statistics
        </Typography>

        <Box
            sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            justifyContent: "space-between",
            }}
        >
            {stats.map((item) => (
            <Card
                key={item.label}
                sx={{
                flex: "1 1 45%",
                p: 2,
                textAlign: "center",
                boxShadow: 2,
                }}
            >
                <Typography
                variant="h6"
                fontWeight={600}
                color={item.color + ".main"}
                >
                {item.value}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                {item.label}
                </Typography>
            </Card>
            ))}
        </Box>
        </Box>

        {/* 📑 PROJECT REPORTS */}
        <Box sx={{ mt: 4 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
            Project Reports
        </Typography>

        {reports?.map((report) => (
            <Card
            key={report.title}
            sx={{
                p: 2,
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
            >
            <Box>
                <Typography variant="subtitle1" fontWeight={600}>
                {report.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                {report.date}
                </Typography>
            </Box>
            <Button
                variant="outlined"
                startIcon={<Download />}
                href={report.link}
            >
                Download
            </Button>
            </Card>
        ))}
        </Box>
        <CommentSection />

      </Box>     
      </Box>

      {/* RIGHT SIDE — RELATED ARTICLES */}
      <Box
        sx={{
          flex: { xs: "1", md: "0 0 15%" },
          borderLeft: { md: "1px solid #eee" },
          pl: { md: 3 },
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Related Articles
        </Typography>

        {
          relatedArticles?.length>0?(
        relatedArticles?.map((article, i) => (
          <Card
            key={i}
            sx={{
              mb: 2,
              boxShadow: 2,
              borderRadius: 2,
              cursor: "pointer",
              transition: "transform 0.3s",
              "&:hover": { transform: "scale(1.03)" },
            }}
          >
            {/*  */}
            
            <CardActionArea component="a" href={article?.url} 
            onClick={() => {
              navigate(`/articles/${article?.title?.slice(0,20)}/${article?.id}/`,{state:{articleId: article.id, articleName: article?.title}})
              
            }}
            >
            <CardMedia
              component="img"
              height="150"
              image={article.img}
              alt={article.title}
            />
            <CardContent>
              <Typography variant="subtitle1" fontWeight={600}>
                {article.title}
              </Typography>
            </CardContent>
            </CardActionArea>
          </Card>
        ))):(
          <h3>No related articles</h3>
        )}
      </Box>
    </Box>
  );
};

export default ProjectDetail;
